'use client';
import PropTypes from 'prop-types';
import { DeletionModal } from '@components/DeletionModal/DeletionModal';
import { EditModal } from '@components/EditModal/EditModal';
import { ApiKeyForm } from '@components/FormComponents/ApiKeyForm/ApiKeyForm';
import { DeleteButton, EditButton } from '../TableActions';
import { deleteApiKey } from '@utils/graphql/creators/apiKeys';
import { MenuItem, Divider } from '@mui/material';
import { useRef } from 'react';
import '../TableActions.css';
import { handleTableActionsKeyDown } from '../utils/helpers';
import { getContactLabelAndName } from '@pages/utils/helpers';

export const ApiKeyActions = ({ rowInfo, id }) => {
  const editButtonRef = useRef(null);
  const deleteButtonRef = useRef(null);
  const buttonArray = [editButtonRef, deleteButtonRef];
  const contactLabel = getContactLabelAndName(rowInfo.contact).label;

  const normalizedData = {
    ...rowInfo,
    // delete button and modal expect a 'name' field
    name: rowInfo.user_key,
  };

  return [
    <MenuItem
      key='edit-apikey-button'
      onKeyDown={(event) => {
        handleTableActionsKeyDown(event, buttonArray, 0);
      }}>
      <EditModal
        data={{
          ...rowInfo,
          contact: {
            ...rowInfo.contact,
            name: contactLabel,
          },
        }}
        FormComponent={ApiKeyForm}
        fieldName='API-key'
        trigger={({ handleOpen }) =>
          <EditButton
            ref={editButtonRef}
            focusIdOnEscape={id}
            handleOpen={handleOpen}
            data={normalizedData}
          />
        }
      />
    </MenuItem>,
    <Divider key='divider' />,
    <MenuItem
      key='delete-apikey-button'
      onKeyDown={(event) => {
        handleTableActionsKeyDown(event, buttonArray, 1);
      }}>
      <DeletionModal
        headerIcon='fa-solid fa-key'
        data={normalizedData}
        handleDelete={deleteApiKey}
        fieldName='API-key'
        trigger={({ handleOpen }) =>
          <DeleteButton
            ref={deleteButtonRef}
            focusIdOnEscape={id}
            handleOpen={handleOpen}
            data={normalizedData}
          />
        }
      />
    </MenuItem>,
  ];
};

ApiKeyActions.propTypes = {
  rowInfo: PropTypes.object,
  id: PropTypes.string,
};